import React from 'react';

const TimezoneOptionRenderer = ({ timezone }) => {
  const timeZoneArray = timezone.split('(');
  if (timeZoneArray.length < 2) {
    return <span>{timezone}</span>;
  }

  return (
    <span>{`${timeZoneArray[0].trim()} (${timeZoneArray[1]}`}</span>
  );
};
export default TimezoneOptionRenderer;
